class CustomCountdownSimple extends HTMLElement {
  constructor() {
    super();
    this.startNode = this.getAttribute("data-start-node");
    this.endNode = this.getAttribute("data-end-node");
    this.timer = null;
  }

  connectedCallback() {
    this.start();
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  start() {
    if (this.timer) clearInterval(this.timer);

    const now = Date.now();
    const start = this.parseDate(this.startNode);
    const end = this.parseDate(this.endNode);

    if (!start || !end) {
      this.hide();
      return;
    }
    const startTime = start.getTime();
    const endTime = end.getTime();
    if (now < startTime || now >= endTime) {
      this.hide();
      return;
    }
    this.update(endTime - now);
    this.timer = setInterval(() => {
      const remain = endTime - Date.now();

      if (remain <= 0) {
        clearInterval(this.timer);
        this.hide();
        return;
      }

      this.update(remain);
    }, 1000);
  }

  update(time) {
    const t = this.getParts(time);
    this.setText(".days", t.days);
    this.setText(".hours", t.hours);
    this.setText(".minutes", t.minutes);
    this.setText(".seconds", t.seconds);
  }

  setText(selector, value) {
    const el = this.querySelector(selector);
    if (el) el.textContent = value;
  }

  hide() {
    const box = this.closest(".announcement-countdown-wrapper") || this;
    box.style.display = "none";
  }

  parseDate(str) {
    if (!str) return null;
    if (str.includes("-") && str.split("-").length > 3) {
      const arr = str.split("-").map(Number);
      const [y, m, d, h = 0, min = 0, s = 0] = arr;
      return new Date(y, m - 1, d, h, min, s);
    }
    const parsed = new Date(str);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  getParts(time) {
    return {
      days: String(Math.floor(time / 86400000)).padStart(2, "0"),
      hours: String(Math.floor(time / 3600000) % 24).padStart(2, "0"),
      minutes: String(Math.floor(time / 60000) % 60).padStart(2, "0"),
      seconds: String(Math.floor(time / 1000) % 60).padStart(2, "0")
    };
  }
}

if (!customElements.get("custom-countdown-simple")) {
  customElements.define("custom-countdown-simple", CustomCountdownSimple);
}